module.exports = "/images/vendor/flag-icon-css/flags/4x3/nu.svg?433deb3d047d08459797f7a9da38685f";